import React, { useContext, useEffect, useState } from 'react';
import functions from '../../utils/functions';
import requests from '../../utils/requests.js';
import { VendorContext } from '../../providers/Vendor.jsx';
import { s } from '../../Style.jsx';
import { PersonContext } from '../../providers/Person.jsx';

const Collapsed = ({ order, setOrder, setViewingOrder }) => {

    const { auth } = useContext(PersonContext);
    const [loading, setLoading] = useState(false);

    const { vendor } = useContext(VendorContext);
    const [timeFrom, settimeFrom] = useState(order.timeFrom);
    useEffect(() => {
        //if timeFrom is not formatted as 00:00 set timeFrom to 20 minutes from now using Intl.Date.. and format to 00:00
        if (!order.timeFrom || order.timeFrom.length !== 5) {
            const date = new Date();
            const time = Intl.DateTimeFormat('en-CA', { timeZone: "America/New_York", hour12: false, hour: '2-digit', minute: '2-digit' }).format(new Date(date.getTime() + (20 * 60 * 1000)));
            const timeString = time.split(' ')[0].split(':').map(t => t.length === 1 ? '0' + t : t).join(':');
            settimeFrom(timeString);
        }else{
            settimeFrom(order.timeFrom);
        }
    }, [timeFrom, order.timeFrom]);

    const updatetimeFrom = (e) => {

        //split timeFrom
        const time = timeFrom.split(":");

        //add (e) to time[1], if below zero or above 60, edit time[0] amd time[1[
        let minutes = parseInt(time[1]) + e;
        let hours = parseInt(time[0]);
        if (minutes < 0) {
            hours--;
            minutes = 60 + minutes;
        } else if (minutes > 59) {
            hours++;
            minutes = minutes - 60;
        }

        const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        settimeFrom(timeString);
        requests.updateOrder({ auth, id: order.id, values: { timeFrom: timeString }, setLoading });
    };

    const capitilizeFirstLetter = (string) => {
        if (!string) return "";
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    if (loading) return <p style={{ textAlign: "center" }}><i className="fas fa-spinner fa-spin"></i></p>;

    const formatDate = (date) => {
        //date is yyyy-mm-dd and i want "May 13"
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString('en-US', options);
    };

    return <>
        <div style={{ ...s.orderBox, cursor: "initial", paddingLeft: "10px", borderLeft: "10px solid #000" }}>

            <div style={{ ...s.row, alignItems: "flex-start" }}>
                <div style={{ flex: 2 }}>
                    <h4 style={{ margin: 0 }}>Order #{order?.id} - <span style={{fontSize:12,color:"#333",fontWeight:"400"}}>{functions.formatMonth[parseInt(order?.date?.split('T')[0].split('-')[1]) - 1]} {parseInt(order?.date?.split('T')[0].split('-')[2])}</span></h4>
                    <span style={{ fontSize: 14 }}>{(vendor?.name || order.pickup)?.split(',')[0]} → {order.address?.split(',')[0]}</span>
                </div>

                <div onClick={() => setViewingOrder(order)} style={{ cursor: "pointer", display: 'flex', justifyContent: "flex-end", textAlign: "right", alignItems: 'center', marginTop: 0, border: "1px solid #ccc", borderRadius: 5 }}>   
                    <span style={{ fontSize: 12, marginRight: 10, marginLeft: 10 }} >{capitilizeFirstLetter(order?.vendor_status)}</span>
                    <s.IconButton icon="fas fa-chevron-right" style={{ marginRight: 10 }} />
                </div>
            </div>

            {order?.vendor_status !== 'complete' && <div style={{ ...s.row, marginTop: 10 }}>

                {order?.vendor_status === 'pending' && <button style={{...s.button, marginBottom: 0, background: "black", color: "white", borderRadius: 5, border: "1px solid black", padding: "4px 20px", }} onClick={() => {
                    setOrder({ ...order, vendor_status: 'accepted' });
                    requests.updateOrder({ auth, id: order.id, values: { vendor_status: 'accepted' } });
                }}>Accept</button>}

                {order?.vendor_status === 'accepted' && <>
                    <label style={{ fontSize: 12, flex: 1 }}>Ready Time: {functions.formatTwelveHour(timeFrom)}</label>
                    <button style={{...s.button, marginBottom: 0}} onClick={() => updatetimeFrom(-5)}>-5</button>
                    <button style={{...s.button, marginBottom: 0}} onClick={() => updatetimeFrom(+5)}>+5</button>

                    <button style={{...s.button, marginBottom: 0, background: "black", color: "white", borderRadius: 5, border: "1px solid black", padding: "4px 20px", }} onClick={() => {
                        setOrder({ ...order, vendor_status: 'ready' });
                        requests.updateOrder({ auth, id: order.id, values: { vendor_status: 'ready', timeFrom } });
                    }}>Ready</button>
                </>}
                
                {order?.vendor_status === 'ready' && <>
                    <button style={{...s.button, marginBottom: 0, background: "black", color: "white", borderRadius: 5, border: "1px solid black", padding: "4px 20px", }} onClick={() => {
                        setOrder({ ...order, vendor_status: 'complete' });
                        requests.updateOrder({ auth, id: order.id, values: { vendor_status: 'complete' } });
                    }}>Complete</button>
                </>}

            </div>}

        </div>
    </>;

}
export default Collapsed;
